import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

interface TotalPolicySoldCount {
  monthCount?: number;
  allTimesCount?: number;
  allTimesSavings?: number;
}

/**
 * Query total policy sold count(offsite + onsite)
 */
export const QUERY_TOTAL_POLICY_SOLD_COUNT: TypedDocumentNode<{
  getTotalPolicySold: TotalPolicySoldCount;
}> = gql`
  query getTotalPolicySold {
    getTotalPolicySold {
      monthCount
      allTimesCount
      allTimesSavings
    }
  }
`;
